import {
  UPDATE_INSTALLMENT_STATUS_LOADING,
  UPDATE_INSTALLMENT_STATUS_SUCCESS,
  UPDATE_INSTALLMENT_STATUS_FAILED,
} from "../types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const updateInstallmentStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_INSTALLMENT_STATUS_LOADING:
      return { ...state, loading: action.loading };
    case UPDATE_INSTALLMENT_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_INSTALLMENT_STATUS_FAILED:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default updateInstallmentStatusReducer;
